<template>
  <div class="header">
    <div class="header-inner">
      <h1 class="logo">
        <router-link to="/tech"
          ><img src="@/assets/images/logo.svg" alt="hyconsoft"
        /></router-link>
      </h1>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
